import React from "react";
import { Card, Typography, Box } from "@mui/material";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { useQuery } from "react-admin";
import jwt_decode from "jwt-decode";

import CardIcon from "./CardIcon";

const getBranchCode = () => {
    try {
        return localStorage.token ? jwt_decode(localStorage.token).branch_code : "";
    } catch (error) {
        console.error("Invalid token:", error);
        return "";
    }
};

const Orphan = () => {
    const branch_code = getBranchCode();

    const { data, loading, error } = useQuery({
        type: "getOne",
        resource: "shipstatuscount",
        payload: { id: `O-${branch_code}` },
    });

    if (loading) return null;
    if (error) return <Typography color="error">Error loading data</Typography>;

    const orphanCount = data?.id || 0;

    return (
        <Box sx={{ flex: 1, margin: "10px 1px" }}>
            <CardIcon Icon={NotInterestedIcon} bgColor="#f44336" />
            <Card
                sx={{
                    overflow: "inherit",
                    textAlign: "center",
                    padding: 1,
                    minHeight: 8,
                    boxShadow: 3,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" color="textSecondary" sx={{ fontWeight: "bold", fontSize: "14px" }}>
                    Orphan ({orphanCount})
                </Typography>
            </Card>
        </Box>
    );
};

export default Orphan;
